import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetSolutionDrugActivities(drugId: string | undefined) {
  return useQuery(queries.drugCatalog.getSolutionActivitiesById(drugId || ''))
}
